import {
  CustomTextField,
  GeneralModal,
  ModalButton,
  SuccessModal,
} from '../index';
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Grid,
} from '@mui/material';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';

import { styled } from '@mui/material/styles';

const CssFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  variant: 'menu',
};

export const MultiMessageModal = (props) => {
  const options = props.options;
  const employeeList = props.employeeList;
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [numViews, setNumViews] = useState(1);
  const [linkTitle1, setLinkTitle1] = useState('');
  const [linkTitle2, setLinkTitle2] = useState('');
  const [linkTitle3, setLinkTitle3] = useState('');
  const [link1, setLink1] = useState('');
  const [link2, setLink2] = useState('');
  const [link3, setLink3] = useState('');
  const [selected, setSelected] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  let empids = [];
  const isAllSelected =
    options.length > 0 && selected.length === options.length;

  // SELECTING MULTIPLE NAMES IN BULK MESSAGE
  const handleMultiSelectChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === 'all') {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
  };

  const handleSend = () => {
    // GET ALL EMPIDS OF THE SELECTED MEMBERS
    selected.forEach((selected) => {
      employeeList.forEach((emp) => {
        if (selected === `${emp.firstname} ${emp.lastname}`) {
          empids.push(emp._id);
        }
      });
    });

    empids.forEach((empid) => {
      fetch(apiUrl('/message'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          empid: empid,
          subject: subject,
          message: message
            .concat(
              `\n${linkTitle1}---${link1}\n${linkTitle2}---${link2}\n${linkTitle3}---${link3}`
            )
            .trim(),
          numviews: numViews,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setSuccessModalOpen(true);
          } else {
            alert(data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return (
    <>
      <GeneralModal
        open={props.open}
        onClose={props.onClose}
        style={{ width: '60%' }}
      >
        <Typography align="center" sx={{ mb: 1, fontWeight: 600 }} variant="h5">
          Send Multiple Clock In Message
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <CssFormControl fullWidth margin="normal" required>
              <InputLabel>Recipients</InputLabel>
              <Select
                multiple
                value={selected}
                onChange={handleMultiSelectChange}
                input={<OutlinedInput label="Recipients" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  sx={
                    isAllSelected
                      ? {
                          bgcolor: 'rgba(144, 202, 249, 0.16)',
                          '&:hover': {
                            bgcolor: 'rgba(144, 202, 249, 0.24)',
                          },
                        }
                      : { bgcolor: 'transparent' }
                  }
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={isAllSelected}
                      indeterminate={
                        selected.length > 0 && selected.length < options.length
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary="Select All" />
                </MenuItem>
                {options.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    <ListItemIcon>
                      <Checkbox checked={selected.indexOf(option) > -1} />
                    </ListItemIcon>
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </CssFormControl>
            <CustomTextField
              onChange={(e) => setSubject(e.target.value)}
              required={true}
              label="Subject"
            />
            <CustomTextField
              onChange={(e) => setMessage(e.target.value)}
              multiline={true}
              required={true}
              label="Message"
            />
            <CustomTextField
              onChange={(e) => setNumViews(e.target.value)}
              defaultValue={1}
              required={true}
              label="Number of Views"
            />
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="column" sx={{ height: '100%' }}>
              <CustomTextField
                onChange={(e) => setLinkTitle1(e.target.value)}
                required={link1 !== '' ? true : false}
                label="Link Title 1"
              />
              <CustomTextField
                onChange={(e) => setLink1(e.target.value)}
                required={linkTitle1 !== '' ? true : false}
                label="Link 1"
              />
              <CustomTextField
                onChange={(e) => setLinkTitle2(e.target.value)}
                required={link2 !== '' ? true : false}
                label="Link Title 2"
              />
              <CustomTextField
                onChange={(e) => setLink2(e.target.value)}
                required={linkTitle2 !== '' ? true : false}
                label="Link 2"
              />
              <CustomTextField
                onChange={(e) => setLinkTitle3(e.target.value)}
                required={link3 !== '' ? true : false}
                label="Link Title 3"
              />
              <CustomTextField
                onChange={(e) => setLink3(e.target.value)}
                required={linkTitle3 !== '' ? true : false}
                label="Link 3"
              />
              <ModalButton
                primaryBtnName="Send"
                secondaryBtnName="Cancel"
                primaryClickHandler={() => {
                  handleSend();
                  props.onClose();
                }}
                secondaryClickHandler={props.secondaryClickHandler}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralModal>
      <SuccessModal
        open={successModalOpen}
        onClose={() => setSuccessModalOpen(false)}
        close={() => setSuccessModalOpen(false)}
        desc={'You have successfully sent a message.'}
      />
    </>
  );
};
